<template>
    <div class="list-pages py-2 d-flex align-items-center">
        <!-- abre modal de criar categoria -->
        <span @click="toggleModalCategory" class="add-category-button">
            <i class="fal fa-plus-circle"></i>
        </span>
        <!-- listagem de categorias -->
        <div
            v-for="item in getCategories"
            class="list-pages-item ml-3"
            :key="item.title"
            :class="isActive(item.title)"
            @click="handleActiveCategory(item)"
        >
            <category @confirmRemoveCategory="confirmRemoveCategory($event)" :item="item" :isModalEventCancelled="isModalEventCancelled" />
        </div>
    </div>
</template>

<script>
import Category from '../atoms/Category.vue';
import { mapGetters } from "vuex";
export default {
    name: "Categories",
    data() {
        return {
            isModalEventCancelled: false,
        }
    },
    components: {
        Category
    },
    computed: {
        ...mapGetters("dashboardModule", [
            "getCategories",
		]),
    },
    props: {
        activeCategories: {
            type: Array,
            required: true
        },
    },
    methods: {
        isActive(title) {
            return this.activeCategories.map(category => category.title == title ? 'item-active' : 'item--inactive')
        },
        toggleModalCategory() {
            this.$bvModal.show('modalCategory');
        },
        checkActiveCategories(title) {
            this.$emit('checkActiveCategories', title);
        },
        handleActiveCategory(element) {
            this.$emit('handleActiveCategory', element);
        },
        confirmRemoveCategory(item) {
            this.$bvModal.msgBoxConfirm(
                "Atenção. Esta categoria será removida de todas as suas publicações. Deseja confirmar esta ação?",
                {
                    title: "Excluir categoria",
                    modalClass: "full-white",
                    size: "md",
                    buttonSize: "sm",
                    cancelVariant: "danger",
                    okTitle: "Excluir",
                    cancelTitle: "Cancelar",
                    footerClass: "p-2",
                    hideHeaderClose: true,
                    centered: true
                }
            )
            .then(value => {
                if (value) {
                    this.$emit('removeCategory', item)
                } else {
                    this.isModalEventCancelled = true;
                }
            });
        },
    },
};
</script>

<style>
#post-settings .list-pages {
    flex-wrap: wrap;
}
#post-settings .list-pages .list-pages-item {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    background-color: #f8f8f8;
    padding: 3px 15px;
    border-radius: 20px;
    color: #a9a9a9;
    border: 1px solid transparent;
    display: inline-block;
    cursor: pointer;
}
#post-settings .list-pages .list-pages-item.item-active {
    border: 1px solid var(--main-color);
    color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/Categories.vue